// components
import { GridContainer } from 'components/shared/Grid/Grid.components';
import WhenSection from '../WhenSection/WhenSection';
import WhatWhereSection from '../WhatWhereSection/WhatWhereSection';
import CommentSection from '../CommentSection/CommentSection';
import EntitySection from '../EntitySection/EntitySection';

// styles
import { FormWrapper } from './FormInputSection.styles';

// types
import type { RefObject } from 'react';
import type { CustomSelectRef } from 'components/shared/Select';

type FormInputSectionProps = {
  activityFieldRef?: RefObject<HTMLInputElement | null>;
  recurrenceFieldRef?: RefObject<CustomSelectRef | null>;
};

const FormInputSection = ({
  activityFieldRef,
  recurrenceFieldRef
}: FormInputSectionProps) => {
  'use memo';
  return (
    <FormWrapper>
      <GridContainer>
        <WhenSection recurrenceFieldRef={recurrenceFieldRef} />
        <WhatWhereSection activityFieldRef={activityFieldRef} />

        <EntitySection planningEntityType="EMPLOYEE" />
        <EntitySection planningEntityType="CLIENT" />
        <EntitySection planningEntityType="RESOURCE" />

        <CommentSection />
      </GridContainer>
    </FormWrapper>
  );
};

export default FormInputSection;
